/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { Injectable } from '@angular/core';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { DataService } from 'app/shared/services/data.service';

@Injectable({ providedIn: 'root' })
export class OrganiserOnboardingService extends DataService<any>  {
constructor(protected dependencies: ApiDependenciesService) {
		super(dependencies);
	}


	get baseEndpoint():string{
		return '/organiser-onboarding';
	}

	get baseUsersEndpoint():string{
		return '/users';
	}

	protected getCreateEndpoint(): string {
		return this.baseEndpoint;
	}

	blockUi(){
		this.startBlockUI();
	}

	async addNew(item):Promise<any>{
		this.startBlockUI();
		let endPoint = this.getCreateEndpoint();
		return this.setEndpoint(endPoint)
		.save(item)
		.finally(() => {
			this.stopBlockUI();
		});
	}


	async generateAndSendOnboardingOtp(userId: number, emailToken: string): Promise<any> {
		let endpoint = this.baseEndpoint + `/generate-and-send-onboarding-otp/${userId}/${emailToken}`;
		return this.setEndpoint(endpoint).save(null);
	}

	termsUrl:string;
	privacyPolicyUrl:string;

	async getConfiguration(): Promise<any>{
		let endpoint = this.baseEndpoint + '/create-organiser/configuration';

		await this.setEndpoint(endpoint)
		.getSingle()
		.then((response) => {
			this.termsUrl=response.termsUrl;
			this.privacyPolicyUrl=response.privacyPolicyUrl;
		})
		.catch(() => {
			this.stopBlockUI();
		});
	}

	async isEmailUnique(currentId:number, value: string): Promise<boolean> {
		return this.isUnique(currentId, 'email', value);
	}

	async isPhoneUnique(currentId:number, value: string): Promise<boolean> {
		return this.isUnique(currentId, 'phone', value);
	}

	async isUnique(currentId:number, name: string, value: string): Promise<boolean>{
		let result = true;
		const endpoint = this.baseUsersEndpoint + `/is-${name}-unique?idToExcludeFromCheck=${currentId ?? 0}&value=${value}`;

		await this.setEndpoint(endpoint)
		.getSingle()
		.then((response: boolean) => {
			result = response;
		});
		return Promise.resolve(result);
	}

}
